// Author Liang Gangqiang
// Date 2021-07-17 11:58:31

import * as model from "@/model/sithMes/quality/SithMesNcrTaskNccItemModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesNcrTaskNccItem(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_QUALITY_URL,
    })
    .buildStore()
